export default "__VITE_ASSET__D3VkMh6V__"